import { uploadToMediaManagement } from "./upload_to_MM.jsx";


export const fetchAudioFile = async ({
        fetchText,
        audioData,
        marketingGoals,
        targetAudience,
        vibeAndTone,
        setUploadAudioID,
        language,
        setAudioUrl,
        setCurrentBalance,
        setSpinning,
        setAllUploadedAudios,
        ChangeFetchAudioFileStatus,
        setFetchonlyAudioStatus,
        getToken,
        configData,
        navigate,
        notify,
        onAudioGenerated,
    }) => {
      if(!fetchText){
        notify("No audio text found", "error");
        setSpinning(prev => ({ ...prev, ["audio"]: false }));
        setSpinning(prev => ({ ...prev, ["audio_only"]: false }));
        setFetchonlyAudioStatus(false);
        return;
      }
        setAudioUrl(null)
        // await sleep(2000);
        // return {
        //     audio_file: false,
        //     offer_id: false
        // };
        
        try {
          const token = getToken()
          const now = new Date();
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const bodyData = {
            ...audioData,
            free_text: fetchText,
            offer_id: `Audio_${audioData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
          }

          const res = await fetch(`${configData.DEMO_URL}/CreateAudio`, {
            method: "POST",
            headers: {
                "x-access-token": token,
                "Content-Type": "application/json",
                // add auth token if needed
             },
            body: JSON.stringify(bodyData),
          });
    
          if (!res.ok) {
            setSpinning(prev => ({ ...prev, ["audio"]: false }));
            let errorMessage = `Request failed (${res.status})`;
            
            try {
              const errorBody = await res.json();
              if (errorBody?.message) {
                errorMessage = errorBody.message;
              }
            } catch (_) {
            }

            const error = new Error(errorMessage);
            error.status = res.status;
            throw error;
          }
    
          const response = await res.json();
          setAudioUrl(`${response.audio_file}`)
          setSpinning(prev => ({ ...prev, ["audio"]: false }));
          setSpinning(prev => ({ ...prev, ["audio_only"]: false }));
          setCurrentBalance(response.current_balance)

          ChangeFetchAudioFileStatus(false);
          setFetchonlyAudioStatus(false);
          const uploadAudioData = {
            audioUrl: response.audio_file,
            audio_id: bodyData.offer_id,
          };
          onAudioGenerated?.({
            audioUrl: response.audio_file,
            audioText: fetchText,
            audio_id: bodyData.offer_id,
          });
          uploadToMediaManagement({
            marketingGoals,
            targetAudience,
            vibeAndTone,
            uploadData: {"uploadAudioData": uploadAudioData},
            setAllUploadedAudios,
            setUploadAudioID,
            getToken,
            configData,
            notify,
          });

          return;
          // setAudioUrl("https://storage.googleapis.com/staging_catch_assets/campaign_audio/1123.wav")
          // setloading(false)
          // return false
    
          // return data; // data should have the same shape as your previous `response.data`
        } catch (error) {
          if (error.status === 401 || error.status === 403) {
            ChangeFetchAudioFileStatus(false);
            navigate("/");
          } else {
            notify(error.message, "error");
            ChangeFetchAudioFileStatus(false);
          }

          setSpinning(prev => ({ ...prev, ["audio"]: false }));
          setSpinning(prev => ({ ...prev, ["audio_only"]: false }));
          ChangeFetchAudioFileStatus(false);
          return;
        }
      };